import jQuery from "jquery";

jQuery(document).ready(function($) {
  $("#offcanvas-nav li.menu-item-has-children > a").each(function() {
    const childMenu = $(this).next("ul");
    const classes = $(this)
      .parent()
      .hasClass("current_page_item")
      ? "parent parent_current_page_item"
      : "parent";

    $(this)
      .clone()
      .prependTo(childMenu)
      .text("Overview")
      .wrap(`<li class="${classes}"></li>`);
  });

});


